import { render, staticRenderFns } from "./PoolShare.vue?vue&type=template&id=9618d4a8&"
import script from "./PoolShare.vue?vue&type=script&lang=js&"
export * from "./PoolShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports